'use client';

import { __spreadArray, __awaiter, __generator } from '../_virtual/_tslib.js';

var hasLocalStorage = !!(typeof window !== 'undefined' && window.localStorage);
var PopupNewUser = /** @class */ (function () {
    function PopupNewUser() {
    }
    PopupNewUser.prototype.initializePopup = function () {
        if (hasLocalStorage) {
            localStorage.setItem('popupNewUser', JSON.stringify([]));
        }
    };
    PopupNewUser.prototype.getPopup = function () {
        if (hasLocalStorage) {
            var popupLocals = localStorage.getItem('popupNewUser');
            popupLocals = popupLocals ? JSON.parse(popupLocals) : [];
            return popupLocals;
        }
        return [];
    };
    PopupNewUser.prototype.setWhenUserClose = function () {
        if (hasLocalStorage) {
            var popupLocals = this.getPopup();
            if (popupLocals.length < 3) {
                var currentTimeStamp = new Date();
                popupLocals = __spreadArray(__spreadArray([], popupLocals, true), [currentTimeStamp.getTime()], false);
                localStorage.setItem('popupNewUser', JSON.stringify(popupLocals));
            }
        }
    };
    PopupNewUser.prototype.getJobLevelList = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url, {
                            method: 'GET'
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PopupNewUser;
}());
var PopupService = new PopupNewUser();

export { PopupNewUser, PopupService as default };
//# sourceMappingURL=PopupService.js.map
